import { useTheme } from '@mui/material';

export const TryAgainIcon = () => {
    const theme = useTheme();
    const {
        stroke: { primary: primaryStroke },
    } = theme.colors.other.icon;

    return (
        <svg xmlns="http://www.w3.org/2000/svg" width={40} height={40} fill="none">
            <path
                stroke={primaryStroke}
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={1.5}
                d="M5.14 19.495a14.096 14.096 0 0 1 6.033-11.567m20.275 4.519a14.096 14.096 0 0 0-17.99-5.815m-2.285 1.296a14.099 14.099 0 0 1 2.286-1.296m-2.286 1.296 2.286-1.296"
            />
            <path
                stroke={primaryStroke}
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={1.5}
                d="M22.761 12.447h8.81v-8.81m1.762 15.858a14.096 14.096 0 0 1-2.911 8.584M7.026 26.543a14.096 14.096 0 0 0 18.585 5.53"
            />
            <path
                stroke={primaryStroke}
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={1.5}
                d="M15.713 26.543h-8.81v8.81"
            />
        </svg>
    );
};
